var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("navbar-breadcrumb", [
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            {
              staticClass: "breadcrumb-item active",
              attrs: { "aria-current": "page" },
            },
            [_vm._v("Dashboard")]
          ),
        ]),
      ]),
      _c("div", { staticClass: "row justify-content-center" }, [
        _c(
          "div",
          { staticClass: "col-2" },
          [
            _c("el-date-picker", {
              staticClass: "mb-2",
              attrs: {
                type: "month",
                size: "medium",
                clearable: false,
                format: "MMMM yyyy",
              },
              on: { change: _vm.getDashboard },
              model: {
                value: _vm.month,
                callback: function ($$v) {
                  _vm.month = $$v
                },
                expression: "month",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "dashboard-summary mb-3" },
            [
              _c(
                "div",
                [
                  _c(
                    "stats-card",
                    {
                      attrs: {
                        title: _vm.formatNumero(_vm.dashboard.totals.national),
                        subTitle: "Nacional",
                      },
                    },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("i", { staticClass: "fa fa-home text-secondary" }),
                      ]),
                      _c("template", { slot: "footer" }, [
                        _c("i", { staticClass: "fa fa-calendar" }),
                        _vm._v(
                          "Mes anterior: " +
                            _vm._s(
                              _vm.formatNumero(
                                _vm.dashboard.totals.national_last
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "stats-card",
                    {
                      attrs: {
                        title: _vm.formatNumero(
                          _vm.dashboard.totals.international
                        ),
                        subTitle: "Internacional",
                      },
                    },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("i", { staticClass: "fa fa-globe text-secondary" }),
                      ]),
                      _c("template", { slot: "footer" }, [
                        _c("i", { staticClass: "fa fa-calendar" }),
                        _vm._v(
                          "Mes anterior: " +
                            _vm._s(
                              _vm.formatNumero(
                                _vm.dashboard.totals.international_last
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._l(_vm.dashboard.couriers_total, function (courier, key) {
                return _c(
                  "div",
                  { key: key },
                  [
                    _c(
                      "stats-card",
                      {
                        attrs: {
                          title: _vm.formatNumero(
                            courier.totales.current_month
                          ),
                          subTitle: _vm.get_courier_text(courier.courier),
                        },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("img", {
                              attrs: {
                                src: _vm.get_courier_logo(courier.courier),
                                alt: courier.courier,
                              },
                            }),
                          ]
                        ),
                        _c("template", { slot: "footer" }, [
                          _c("i", { staticClass: "fa fa-calendar" }),
                          _vm._v(
                            "Mes anterior: " +
                              _vm._s(
                                _vm.formatNumero(courier.totales.latest_month)
                              ) +
                              " "
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c("div", { staticClass: "row pb-3" }, [
            _c("div", { staticClass: "col-md-6 col-sm-12" }, [
              _c("div", { staticClass: "card h-100" }, [
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c("h4", { staticClass: "card-title card-title-seccion" }, [
                      _vm._v("Top 10 de ubicaciones de entrega"),
                    ]),
                    _vm.loading
                      ? _c("el-skeleton", {
                          staticClass: "w-100 p-2",
                          style: _vm.chartStyles,
                          attrs: { animated: "", rows: 6 },
                        })
                      : _c("CitiesPieChart", {
                          staticClass: "p-2",
                          attrs: {
                            data: _vm.dashboard.cities,
                            height: _vm.chartHeight,
                            styles: _vm.chartStyles,
                          },
                        }),
                  ],
                  1
                ),
              ]),
            ]),
            _c("div", { staticClass: "col-md-6 col-sm-12" }, [
              _c("div", { staticClass: "card h-100" }, [
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c("h4", { staticClass: "card-title card-title-seccion" }, [
                      _vm._v("Top 10 servicios"),
                    ]),
                    _vm.loading
                      ? _c("el-skeleton", {
                          staticClass: "w-100 p-2",
                          style: _vm.chartStyles,
                          attrs: { animated: "", rows: 4 },
                        })
                      : _c("ServicesBarChart", {
                          staticClass: "p-2",
                          attrs: {
                            data: _vm.dashboard.services,
                            height: _vm.chartHeight,
                            styles: _vm.chartStyles,
                          },
                        }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12 col-sm-12" }, [
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c("h4", { staticClass: "card-title card-title-seccion" }, [
                      _vm._v("Envíos por transporte"),
                    ]),
                    _vm.loading
                      ? _c("el-skeleton", {
                          staticClass: "w-100 p-2",
                          style: _vm.chartStyles,
                          attrs: { animated: "", rows: 6 },
                        })
                      : _c("PartnersChart", {
                          staticClass: "p-2",
                          attrs: {
                            data: _vm.dashboard.couriers,
                            month: _vm.month,
                            height: _vm.chartHeight,
                            styles: _vm.chartStyles,
                          },
                        }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }